export default __webpack_public_path__ + "static/media/slide3.1209b7e3.webp";